<template>
  <div id="app">



    <!-- Экран "сессия истекла": белый фон на весь экран + центрированная панель -->
    <div
        v-if="!isAuthenticated && !['AuthEntry','Callback'].includes($route.name as string)"
        class="session-expired-wrap"
    >
      <el-card class="session-card" shadow="always">
        <h2>Ваша сессия истекла</h2>
        <p class="muted">Пожалуйста, войдите снова.</p>
        <div class="session-actions">
          <el-button type="primary" size="large" @click="goToStart">Перейти в начало</el-button>

        </div>
      </el-card>
    </div>

    <div v-if="$route.name === 'AuthEntry' || $route.name === 'Callback'">
      <router-view />
    </div>
    <div
      v-if="isAuthenticated && showMenu && $route.name !== 'AuthEntry' && $route.name !== 'Callback'"
      class="admin-layout"
    >
      <el-container>
        <el-aside width="250px" class="sidebar">
          <div class="logo">
            <h2>SAO Admin</h2>
          </div>
          <el-menu
            :default-active="defaultMenuActive"
            router
            class="sidebar-menu"
            background-color="#001529"
            text-color="#fff"
            active-text-color="#1890ff"
          >
            <!-- Для isAdmin -->
            <el-menu-item v-if="isAdmin" index="/dashboard">
              <el-icon><House /></el-icon>
              <span>Dashboard</span>
            </el-menu-item>
            <el-sub-menu v-if="isAdmin" index="/price">
              <template #title>
                <el-icon><Money /></el-icon>
                <span>Prices</span>
              </template>
              <el-menu-item index="/prices">Price activations</el-menu-item>
              <el-menu-item index="/price-activations">Price rental</el-menu-item>
            </el-sub-menu>
            <el-sub-menu v-if="isAdmin" index="/reference">
              <template #title>
                <el-icon><Setting /></el-icon>
                <span>Reference</span>
              </template>
              <el-menu-item index="/reference/countries">Countries</el-menu-item>
              <el-menu-item index="/reference/services">Services</el-menu-item>
            </el-sub-menu>
            <!-- Для isAdmin и isPPA -->
            <el-menu-item v-if="isAdmin || isPPA" index="/log">
              <el-icon><Clock /></el-icon>
              <span>Log</span>
            </el-menu-item>
            <el-menu-item v-if="isAdmin || isPPA" index="/users">
              <el-icon><User /></el-icon>
              <span>Users</span>
            </el-menu-item>

            <el-menu-item v-if="isAdmin " index="/topups">
              <el-icon><Coin /></el-icon>
              <span>TopUps</span>
            </el-menu-item>

            <el-menu-item v-if="isAdmin" index="/paidusers">
              <el-icon><Wallet /></el-icon>
              <span>Paid users</span>
            </el-menu-item>




            <el-menu-item @click="logout">
              <el-icon><SwitchButton /></el-icon>
              <span>Logout</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-container>
          <el-main class="main-content">
            <router-view />
          </el-main>
        </el-container>
      </el-container>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useKeycloak } from '@josempgon/vue-keycloak'
import { useRouter, useRoute } from 'vue-router'
import {
  House,
  Money,
  Setting,
  SwitchButton,
  Clock,
  User,
  Coin,
  Wallet

} from '@element-plus/icons-vue'

const router = useRouter()
const route = useRoute()
const { keycloak, isAuthenticated } = useKeycloak()

function goToStart() {
  router.push({ name: 'AuthEntry' })
}

async function logout() {
  await keycloak.value.logout({ redirectUri: `${window.location.origin}/callback` })
}

// --- роли и доступ ---
import { computed } from 'vue'
const userInfo = computed(() => keycloak.value && keycloak.value.tokenParsed ? keycloak.value.tokenParsed : null)

const isPPA = computed(() => {
  const info = userInfo.value
  if (!info) return false
  if (Array.isArray(info.roles) && info.roles.includes('ROLE_ppa')) return true
  if (info.resource_access) {
    for (const res in info.resource_access) {
      const roles = info.resource_access[res]?.roles || []
      if (roles.includes('ppa')) return true
    }
  }
  return false
})

const isAdmin = computed(() => {
  const info = userInfo.value
  if (!info) return false
  if (Array.isArray(info.roles) && info.roles.includes('ROLE_superadmin')) return true
  if (info.resource_access) {
    for (const res in info.resource_access) {
      const roles = info.resource_access[res]?.roles || []
      if (roles.includes('ROLE_superadmin')) return true
    }
  }
  return false
})

// --- меню ---
const showMenu = computed(() => isAdmin.value || isPPA.value)

// --- дефолтный активный пункт меню ---
const defaultMenuActive = computed(() => {
  // Для PPA по умолчанию Log
  if (isPPA.value && !isAdmin.value) return '/log'
  // Для админа - текущий путь
  return route.path
})
</script>

<style scoped>
.loading-screen {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}


.admin-layout {
  height: 100vh;
}

.sidebar {
  background-color: #001529;
  height: 100vh;
}

.logo {
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid #1f1f1f;
}

.logo h2 {
  color: white;
  margin: 0;
  font-size: 18px;
}

.sidebar-menu {
  border: none;
}

.header {
  background: white;
  border-bottom: 1px solid #f0f0f0;
  padding: 0;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 24px;
}

.header-left h3 {
  margin: 0;
  color: #333;
}

.user-dropdown {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #333;
}

.main-content {
  background: #f5f5f5;
  min-height: calc(100vh - 60px);
}
</style>
